module.exports = __webpack_public_path__ + "img/dl.15ea6367.jpg";